import { render, staticRenderFns } from "./ProductsOverview.vue?vue&type=template&id=132e81ee&scoped=true&"
import script from "./ProductsOverview.vue?vue&type=script&lang=js&"
export * from "./ProductsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProductsOverview.vue?vue&type=style&index=0&id=132e81ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132e81ee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsOverviewMedia: require('/app/appsumo/nuxt/components/products/overview/ProductsOverviewMedia.vue').default,Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
